var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full inset-0"},[_c('b-loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"chart-container",attrs:{"id":_vm.chartContainerName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }